import { render, staticRenderFns } from "./TwoColumnText.vue?vue&type=template&id=59166e94"
import script from "./TwoColumnText.vue?vue&type=script&lang=js"
export * from "./TwoColumnText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports